const routes = {
  rates: 'Tasas',
  parents: 'Padres',
  newScenario: 'Nuevo escenario',
  viewSites: 'Ver sitios',
  sites: 'Sitios',
  attributes: 'Atributos',
  suppliers: 'Proveedores',
  updateSupplier: 'Actualizar proveedor',
  createSupplier: 'Crear proveedor',
  shuttles: 'Shuttles',
  updateShuttle: 'Actualizar Shuttle',
  createShuttle: 'Crear Shuttlees',
  fares: 'Tarifas',
  updateFare: 'Actualizar tarifa',
  createFare: 'Crear tarifa',
  services: 'Servicios',
  updateService: 'Servicio de actualización',
  createService: 'Crear servicio',
  users: 'Usuarios',
  updateUser: 'Actualizar usuario',
  createUser: 'Crear usuario',
  vehicles: 'Vehículos',
  updateVehicle: 'Actualizar Vehículo',
  createVehicle: 'Crear Vehículo',
  areas: 'Zonas',
  updateArea: 'Zona de actualización',
  createArea: 'Crear zona',
  drivers: 'Conductores',
  updateDriver: 'Actualizar conductor',
  createDriver: 'Crear conductor',
  playground: 'Zona de juegos',
  support: 'Soporte',
  parameters: 'Parámetros',
  createParameter: 'Crear parámetro',
  analytics: 'Analíticas',
  settings: 'Configuraciones',
  liveMap: 'Mapa en Vivo',
  driverShifts: 'Turnos del conductor',
  driverShiftsTemplates: 'Plantillas de turnos',
  createDriverShift: 'Crear un turno de conductor único',
  createMultipleDriverShifts: 'Crear varios turnos de conductor',
  passengers: 'Pasajeros',
  students: 'Alumnos',
  employees: 'Empleados',
  editShuttle: 'Editar Shuttle',
  updatePassenger: 'Editar pasajero',
  createPassenger: 'Nuevo pasajero',
  onlineDrivers: 'Conductores en línea',
  trips: 'Viajes',
  productionTrips: 'Viajes de producción',
  reservations: 'Reservas',
  editReservation: 'Editar reserva',
  createReservation: 'Crear reserva',
  createQuick: 'Crear rápido',
  timeline: 'Línea de tiempo',
  feedbacks: 'Comentarios',
  home: 'Control de la misión',
  import: 'Cargar datos',
  reports: 'Informes',
  shuttleReports: 'Informes de Shuttle',
  locations: 'Ubicaciones',
  createLocation: 'Crear ubicación',
  editLocation: 'Actualizar ubicación',
  profiles: 'Perfiles',
  shifts: 'Turnos',
  createShift: 'Crear turno',
  updateShift: 'Actualizar turno',
  agentHome: 'Agente',
  createExtraService: 'Servicio extra de Creta',
  updateExtraService: 'Actualizar servicio adicional',
  extraServices: 'Servicios extra',
  tripsPaxReports: 'Resumen de Expediciones / Pasajeros',
  uniqueDriversReport: 'Conductores únicos por día',
  permissions: 'Roles y permisos',
  createJob: 'Crear reserva',
  quickJob: 'Reserva rápida',
  onboarding: 'Generador de escenarios - NEMT',
  holidays: 'Vacaciones',
  blacklist: 'Blacklist',
  integrations: 'Integraciones',
  automations: 'Automatizaciones',
  jobsCalendar: 'Calendario de reserva',
  caregivers: 'Cuidadores',
  customRules: 'Reglas personalizadas',
  billReports: 'Informe de Facturación',
  performanceOverview: 'Visión general del rendimiento',
  facilities: 'Instalaciones',
  roiSimulation: 'Simulación de ROI',
  apiKeys: 'Claves API',
};

export default routes;
